import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AttendancesRoutingModule } from './attendances-routing.module';
import { AttendancesDetailsComponent } from './components/attendances-details/attendances-details.component';
import { AttendancesViewComponent } from './components/attendances-view/attendances-view.component';
import { AttendanceComponent } from './attendance.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AttendanceCreateComponent } from './components/attendance-create/attendance-create.component';

@NgModule({
  declarations: [
     AttendancesDetailsComponent,
     AttendancesViewComponent, 
     AttendanceComponent, AttendanceCreateComponent],
  imports: [
    CommonModule,
    AttendancesRoutingModule,
    SharedModule
  ]
})
export class AttendancesModule { }
